export default "__VITE_ASSET__A9o9$kb3__"